import { useTranslation } from 'react-i18next';
import { PatternFormat } from 'react-number-format';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function AddressForm({ consumer, formErrors, handleChange, renderError }) {
  const { t } = useTranslation();

  return (
    <>
      <Form.Group className="mb-3">
        <Form.Control
          className={formErrors && formErrors.addressLine1 ? 'bo-input bo-input-error' : 'bo-input'}
          type="text"
          name="addressLine1"
          id="addressLine1"
          placeholder={t('pages.signup_details_second.address_form.line_first_placeholder')}
          value={consumer.addressLine1 ? consumer.addressLine1 : ''}
          noValidate
          onChange={e => handleChange(e)}
        />
        {'addressLine1' in formErrors ? renderError(formErrors.addressLine1) : ''}
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Control
          className={formErrors && formErrors.addressLine2 ? 'bo-input bo-input-error' : 'bo-input'}
          type="text"
          name="addressLine2"
          id="addressLine2"
          placeholder={t('pages.signup_details_second.address_form.line_second_placeholder')}
          value={consumer.addressLine2 ? consumer.addressLine2 : ''}
          noValidate
          onChange={e => handleChange(e)}
        />
        {'addressLine2' in formErrors ? renderError(formErrors.addressLine2) : ''}
      </Form.Group>
      <Row>
        <Col xs={8}>
          <Form.Group className="mb-3">
            <Form.Control
              className={formErrors && formErrors.city ? 'bo-input bo-input-error' : 'bo-input'}
              type="text"
              name="city"
              id="city"
              placeholder={t('pages.signup_details_second.address_form.city_placeholder')}
              value={consumer.city ? consumer.city : ''}
              noValidate
              onChange={e => handleChange(e)}
            />
            {'city' in formErrors ? renderError(formErrors.city) : ''}
          </Form.Group>
        </Col>
        <Col xs={4}>
          <Form.Group className="mb-3">
            <Form.Control
              className={formErrors && formErrors.state ? 'bo-input bo-input-error' : 'bo-input'}
              type="text"
              name="state"
              id="state"
              placeholder={t('pages.signup_details_second.address_form.state_placeholder')}
              value={consumer.state ? consumer.state : ''}
              noValidate
              onChange={e => handleChange(e)}
              maxLength={2}
            />
            {'state' in formErrors ? renderError(formErrors.state) : ''}
          </Form.Group>
        </Col>
      </Row>
      <Form.Group className="mb-3">
        <PatternFormat
          name="zip"
          id="zip"
          format="#####"
          mask="_"
          className={formErrors && formErrors.zip ? 'bo-input bo-input-error' : 'bo-input'}
          placeholder={t('pages.signup_details_second.address_form.zip_placeholder')}
          customInput={Form.Control}
          value={consumer.zip ? consumer.zip : ''}
          onChange={e => handleChange(e)}
        />
        {'zip' in formErrors ? renderError(formErrors.zip) : ''}
      </Form.Group>
    </>
  );
}

export default AddressForm;
